module.exports = __webpack_public_path__ + "img/fosun-logo-text@2x.2256ec4d.png";